import React from "react";

const MobileMasteryLeft = () =>
{
    return (<div className="pr-1">
        <img src="/SectionImages/mobile-mastery.webp" />
    </div>)
}

export default MobileMasteryLeft;